/**
 * ITER310 · Loyalty gift short-link resolver.
 *
 * Route: /g/:code
 * - Calls GET /api/loyalty/g/:code (public) → { public_token }.
 * - Client-side redirects (`replace`) to /loyalty/gift/{public_token}.
 * - Never rendered visibly for successful lookups; on 404 shows a
 *   compact "gift link expired or invalid" message with a link home.
 */
import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';

export default function GiftShortRedirect() {
  const { code } = useParams();
  const [state, setState] = useState({ token: null, error: null });

  useEffect(() => {
    const api = process.env.REACT_APP_BACKEND_URL;
    fetch(`${api}/api/loyalty/g/${encodeURIComponent(code || '')}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((d) => setState({ token: d.public_token, error: null }))
      .catch(() => setState({ token: null, error: 'expired' }));
  }, [code]);

  if (state.token) {
    return <Navigate to={`/loyalty/gift/${state.token}`} replace />;
  }
  if (state.error) {
    return (
      <div style={{ minHeight: '100vh', background: '#0F1B3E', color: '#fff',
                     display: 'flex', alignItems: 'center', justifyContent: 'center',
                     fontFamily: 'ui-sans-serif, system-ui, sans-serif', padding: '2rem' }}
           data-testid="gift-shortlink-expired">
        <div style={{ maxWidth: 380, textAlign: 'center' }}>
          <div style={{ fontSize: 42, marginBottom: 12 }}>🎁</div>
          <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 6 }}>
            This gift link isn't active
          </div>
          <div style={{ opacity: 0.75, fontSize: 14, lineHeight: 1.5 }}>
            The link may have expired or been mistyped. Ask the sender to share
            a fresh link.
          </div>
        </div>
      </div>
    );
  }
  return null;   // brief no-flash while lookup is in-flight
}
